@if (isLoading()) {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
} @else {
  <oui-date-picker
    label="Date de début de validité"
    placeholder="JJ/MM/AAAA"
    [control]="form.get('dateDebutValidite')"
    [errors]="dateValidationErrors"
    (valueChange)="setDateFinDeValidite($event)"></oui-date-picker>

  <span class="subtitle-2">Adresse</span>
  <div class="oui-form-line">
    <lib-adresse-autocomplete
      class="oui-form-field-lg"
      [control]="form.get('voie')!"
      (addressChange)="onAdressSelect($event)">
    </lib-adresse-autocomplete>
  </div>
  <oui-textfield
    label="Code postal"
    [regexFilter]="numbersRegex"
    [control]="form.get('codePostal')"></oui-textfield>
  <oui-textfield label="Ville" [control]="form.get('ville')"></oui-textfield>
  <oui-select
    label="Pays"
    [options]="countriesOptions()"
    [control]="form.get('pays')"></oui-select>

  <span class="subtitle-2">Agent commercial</span>
  <oui-textfield
    label="Nom commercial"
    [control]="form.get('nomCommercial')"></oui-textfield>
  <div class="infosbulle-field oui-form-field-md">
    <oui-textfield
      [regexFilter]="numbersRegex"
      label="N° SIRET"
      [control]="form.get('numeroSiret')"
      [errors]="siretErrors"></oui-textfield>
    <oui-infos-bulle bulleTitle="SIRET">
      Le SIRET est composé de 14 chiffres : le numéro SIREN figurant sur le KBIS suivi du
      NIC, un numéro à 5 chiffres identifiant l'établissement et généralement commençant
      par 000</oui-infos-bulle
    >
  </div>
}
